import { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import CartWidget from './CartWidget'

export default function Navbar () {
  const [menu, setMenu] = useState(false)

  function toggleMenu () {
    setMenu(!menu)
  }

  function handleClickMenu (e) {
    if (e.target.matches('.navbar-menu a') || e.target.matches('.navbar-header a *')) {
      setMenu(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickMenu)

    return () => {
      document.removeEventListener('click', handleClickMenu)
    }
  }, [])

  return (
    <nav className='navbar'>
      <div className={`navbar-menu ${menu ? 'is-active' : ''}`}>
        <ul>
          <NavLink to='/' activeclassname='active'>
            INICIO
          </NavLink>
          <NavLink to='/productos' activeclassname='active'>
            PRODUCTOS
          </NavLink>
          <NavLink to='/nosotros' activeclassname='active'>
            NOSOTROS
          </NavLink>
        </ul>
      </div>
      <div className='navbar-header'>
        <button onClick={toggleMenu}>
          <svg viewBox='0 0 24 24'>
            <path
              fill='currentColor'
              d='M4 18q-.425 0-.712-.288Q3 17.425 3 17t.288-.712Q3.575 16 4 16h16q.425 0 .712.288q.288.287.288.712t-.288.712Q20.425 18 20 18Zm0-5q-.425 0-.712-.288Q3 12.425 3 12t.288-.713Q3.575 11 4 11h16q.425 0 .712.287q.288.288.288.713t-.288.712Q20.425 13 20 13Zm0-5q-.425 0-.712-.287Q3 7.425 3 7t.288-.713Q3.575 6 4 6h16q.425 0 .712.287Q21 6.575 21 7t-.288.713Q20.425 8 20 8Z'
            />
          </svg>
        </button>
        <NavLink to='/'>
          <img src='../mohana-logo.png' alt='mohana logo' />
        </NavLink>
        <NavLink to='/cart'>
          <CartWidget />
        </NavLink>
      </div>
    </nav>
  )
}
